export default __webpack_public_path__ + "static/media/trolley.d994ae80.png";